enum DistanceUnit {
  KM = "km",
  MILE = "mi", // it's "mi" because this is what platform returns
}

export default DistanceUnit;
